import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "select-search"
};
import { ref } from 'vue';
import { getAllTenantData } from '@/api/tenant';
// import { useVModel } from '@vueuse/core'

export default {
  __name: 'index',
  props: {
    modelValue: {
      type: [Number, String]
    }
  },
  emits: ['selectChange', 'update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    console.log('props.modelValue', props.modelValue);
    const emits = __emit;

    // const searchValue = useVModel(props)
    const tenantLoading = ref(false);
    const tenantOptions = ref([]);
    const getData = async (query = '') => {
      tenantLoading.value = true;
      const res = await getAllTenantData({
        pageSize: 200,
        currentPage: 1,
        isParent: 1,
        keyword: query
      });
      tenantOptions.value = res.records.map(item => ({
        ...item
      }));
      tenantLoading.value = false;
    };
    getData();
    const remoteMethod = async query => {
      if (query) {
        await getData(query);
      } else {
        tenantOptions.value = [];
      }
    };
    const handleSelectClear = () => {
      emits('selectChange', '');
    };
    const handleSelectChange = val => {
      /* eslint-disable */
      if (val || val == '0') {
        const name = tenantOptions.value.find(item => (item === null || item === void 0 ? void 0 : item.id) === val).name;
        emits('update:modelValue', val + '');
        emits('selectChange', name);
      } else {
        emits('selectChange', '');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_select, {
        "model-value": __props.modelValue == '' ? '' : parseInt(__props.modelValue),
        filterable: "",
        remote: "",
        "reserve-keyword": "",
        placeholder: "请输入租户关键字",
        "remote-method": remoteMethod,
        loading: tenantLoading.value,
        style: {
          "width": "250px"
        },
        onChange: handleSelectChange,
        clearable: "",
        onClear: handleSelectClear
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenantOptions.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.name,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["model-value", "loading"])]);
    };
  }
};